/** @format */

import Messages from "./Messages";

/**
 * Ajax Form Submit Event Delegation
 *
 * All forms with an [data-request-validation] attribute will run through this.
 *
 * Options can be added as data-attributes, e.g. <form data-request-validation data-field-error-messages="true" data-form-message="false">
 *
 *

data-form-message - Prepend form with error/success message - default true
data-field-error-classes - Adds is-erroneous class to each form field which didn't pass validation - default true
data-field-error-messages - Adds specific error message after each form field - default false
 */

$(function () {
	$('input[name="_resolution"]').val(window.screen.width + "x" + window.screen.height);
});

$(document).on("ajax:request-error", "[data-request-validation]", function (event) {
	console.log("request error event", event);
	try {
	var $form = $(this),
		fixedMessage = $form.attr("data-form-fixed-message") || true,
		prependMessage = $form.attr("data-form-message") || false,
		appendMessage = $form.attr("data-form-message-bottom") || false,
		addErrorClasses = $form.attr("data-field-error-classes") || true,
		addErrorMessagesToFields = $form.attr("data-field-error-messages") || true;

	// Properly handle October CMS 4.1 error structure with robust null checking
	var errorMessage = null;
	var errorFields = null;
	var eventDetail = event.detail || {};
	var eventMessage = eventDetail.message;
	console.log("eventDetail", eventDetail);
	var eventEnv = eventMessage && eventMessage.$env ? eventMessage.$env : null;

	if (eventEnv) {
		errorMessage = eventEnv.message || null;
		errorFields = eventEnv.invalid || null;
	}

	// Destructure from event.detail
	const { context, message: frameworkMessage, xhr } = eventDetail;

	console.log("request errorMessage", errorMessage);
	console.log("request errorFields", errorFields);
	console.log("request frameworkMessage", frameworkMessage);
	console.log("request context", context);
	console.log("request xhr", xhr);

	// Robust error extraction pattern
	errorMessage =
		errorMessage ||
		(frameworkMessage && frameworkMessage.message) ||
		(xhr && xhr.responseJSON && xhr.responseJSON.message) ||
		"An error occurred while submitting the form. Please check your input and try again.";

	if ($form.data("default-error-message")) {
		errorMessage = $form.data("default-error-message");
	}

	var message =
		'<div class="form-response form-error-message alert alert-danger">' +
		errorMessage +
		"</div>";

	// Remove old ones
	$(".form-fixed-response").remove();
	$form.find(".form-error-message").remove();

	// Add fixed error message to page
	if (fixedMessage === true) {
		Messages.error(errorMessage);
	}

	if (prependMessage === true) {
		// Prepend error message
		$form.prepend(message);
	}

	if (appendMessage === true) {
		// Append error message
		$form.append(message);
	}

	if (addErrorClasses === true || (addErrorMessagesToFields === true && errorFields)) {
		// Remove fields with error class
		$form.find(":input.is-erroneous").removeClass("is-erroneous");
		$form.find(".select2-container").removeClass("is-erroneous");
		// Remove field error message
		$form.find(".input-error-message").remove();

		if (errorFields) {
			$.each(errorFields, function (field, message) {
				// fixes names and messages of fields in an array
				if (field.indexOf(".") !== -1) {
					field = field.replace(".", "[") + "]";
					message[0] = message[0].replace(".", " ");
				}

				var $field = $form.find(':input[name="' + field + '"]');

				if (addErrorClasses === true) $field.addClass("is-erroneous");
				if (addErrorMessagesToFields === true) {
					if ($field.attr("type") === "checkbox") {
						$field
							.parent(".form-check")
							.append('<div class="input-error-message">' + message[0] + "</div>");
					} else if ($field.attr("type") === "radio") {
						$field
							.parents(".form-group")
							.append('<div class="input-error-message">' + message[0] + "</div>");
					} else if ($field.is("select")) {
						$field
							.parents(".form-group")
							.append('<div class="input-error-message">' + message[0] + "</div>");
						$field
							.parents(".form-group")
							.find(".select2-container")
							.addClass("is-erroneous");
					} else {
						$field.after('<div class="input-error-message">' + message[0] + "</div>");
					}
				}

				if ($field.length == 0) {
					var $label = $form
						.find(':input[name="' + field + '[]"]')
						.parents(".form-group")
						.first("label");
					if (addErrorMessagesToFields === true)
						$label.after('<div class="input-error-message">' + message[0] + "</div>");
				}
			});
		}
	}

	// This prevents the alert from showing.
	return false;
	} catch (err) {
		console.error("Request validation error handler failed", err, event);
		return false;
	}
});

$(document).on("ajax:request-success", "[data-request-validation]", function (event) {
	const { context } = event.detail;
	// Only run if the AJAX handler matches the form's data-request (prevents file upload from triggering form logic)
	var formHandler = $(this).attr("data-request");

	if (!context || !context.handler || formHandler !== context.handler) {
		return;
	}

	var $form = $(this),
		fixedMessage = $form.attr("data-form-fixed-message") || true,
		prependMessage = $form.attr("data-form-message") || false,
		appendMessage = $form.attr("data-form-message-bottom") || false,
		clearForm = $form.attr("data-clear-on-success") || true,
		successMessage =
			$form.attr("data-success-message") ||
			"Thanks, your message has been submitted successfully",
		disableSuccessMessage = $form.attr("data-disable-success-message") || false;

	// Remove fixed form message (only success messages, not errors)
	$(".form-fixed-response.alert-success").fadeOut(300, function () {
		$(this).remove();
	});

	// Remove prepended error message
	$form.find(".form-error-message").remove();

	// Remove fields with error class
	$form.find(":input.is-erroneous").removeClass("is-erroneous");
	$form.find(".select2-container").removeClass("is-erroneous");

	// Remove field error message
	$form.find(".input-error-message").remove();

	var message =
		'<div class="form-response form-error-message alert alert-success">' +
		successMessage +
		"</div>";

	if (disableSuccessMessage === false) {
		// Add fixed success message to page
		if (fixedMessage === true) {
			Messages.success(successMessage);
		}

		// Prepend success message
		if (prependMessage === true) {
			$form.prepend(message);
		}

		// Append success message
		if (appendMessage === true) {
			$form.append(message);
		}
	}

	if (clearForm === true) {
		$form
			.find(":input")
			.removeAttr("checked")
			.removeAttr("selected")
			.not("[type=checkbox], [type=radio], :button, :submit, :reset, :hidden")
			.val("");
	}

	// remove success labels after 5 secs
	setTimeout(function () {
		$form.find(".form-error-message").slideUp(400, function () {
			$(this).remove();
		});
	}, 5000);
});

$(document).on("ajax:request-success", "[data-ga-event]", function (event) {
	const { context } = event.detail;
	var $this = $(this);

	var eventAction = $this.data("ga-action") ? $this.data("ga-action") : "submit";

	if (typeof gtag === "function") {
		gtag("event", eventAction, {
			event_category: $this.data("ga-category"),
			event_label: $this.data("ga-label"),
		});
	} else if (typeof ga === "function") {
		ga("send", {
			hitType: "event",
			eventCategory: $this.data("ga-category"),
			eventAction: eventAction,
			eventLabel: $this.data("ga-label"),
		});
	}
});

// Custom success script (october one can be tempremental)
$(document).on("ajax:request-success", "[data-success-script]", function (event) {
	var $form = $(this);

	eval($form.data("success-script"));
});

// disable submit button when making request
$(document).on("submit", "[data-request]", function () {
	var $form = $(this),
		$submit = $form.find('[type="submit"]');

	$submit.prop("disabled", true);
});

// re-enable submit button after request is done
$(document).on("ajax:request-complete", "[data-request]", function () {
	var $form = $(this),
		$submit = $form.find('[type="submit"]');

	$submit.prop("disabled", false);
});

$(document).on("ajax:request-success", "[data-flash-message]", function () {
	Messages.success($(this).data("flash-message"));
});
